import { render, staticRenderFns } from "./ConcatFooterButton.vue?vue&type=template&id=6ff87fe4&scoped=true&"
import script from "./ConcatFooterButton.vue?vue&type=script&lang=ts&"
export * from "./ConcatFooterButton.vue?vue&type=script&lang=ts&"
import style0 from "./ConcatFooterButton.vue?vue&type=style&index=0&id=6ff87fe4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff87fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
